'use client';

// Barra de pestañas inferior del panel en móvil (< 768 px, design-system §5.1):
// Inicio · Chats · Pedidos · Inventario · Más. Fija abajo y respetando la zona segura
// del indicador de inicio (env(safe-area-inset-bottom)).
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { cn } from '@vendedor/ui';
import { getActiveTabId, getTabBarItems } from '@/lib/navigation';
import { NavIcon } from './nav-icon';

const tabs = getTabBarItems();

export function TabBar() {
  const pathname = usePathname();
  const activeId = getActiveTabId(pathname);

  return (
    <nav
      aria-label="Secciones del panel"
      className="fixed inset-x-0 bottom-0 z-10 border-t border-border bg-surface pr-[env(safe-area-inset-right)] pb-[env(safe-area-inset-bottom)] pl-[env(safe-area-inset-left)] md:hidden"
    >
      <ul className="m-0 grid list-none grid-cols-5 p-0">
        {tabs.map((tab) => {
          const active = tab.id === activeId;
          return (
            <li key={tab.id}>
              <Link
                href={tab.href}
                aria-current={active ? 'page' : undefined}
                className={cn(
                  'flex min-h-14 flex-col items-center justify-center gap-1 px-1 text-xs no-underline',
                  'transition-colors duration-(--motion-fast) ease-standard',
                  'focus-visible:shadow-focus focus-visible:outline-none',
                  active ? 'font-bold text-accent' : 'font-medium text-muted',
                )}
              >
                <NavIcon name={tab.icon} size={22} />
                <span>{tab.shortLabel}</span>
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
